import category from './category';
import tag from './tag';
import frontPage from './front-page';
import page from './page';
import single from './single';

export default {
  category,
  tag,
  'front-page': frontPage,
  page,
  single,
};
